import { useTranslation } from "react-i18next";
import type { LvMatchValueProps } from "./types";

export const LvMatchValue = ({ lvMatch }: LvMatchValueProps) => {
  const { t } = useTranslation();

  const hasValidLvMatch = !!lvMatch?.lvId && lvMatch.confidence !== "low";

  if (hasValidLvMatch) {
    return (
      <span className="block text-sm font-bold text-green-600 mt-0.5 truncate">
        {lvMatch?.lvId}
      </span>
    );
  }

  return (
    <span className="block text-sm font-bold text-red-500 mt-0.5 truncate">
      {t("smartSurveyor.groupInspector.noMatch")}
    </span>
  );
};
